export const pluginPrefix = 'PLUGIN:PNP_RETURN_TAG:';
export const ENTER_RETURN_TAG = `${pluginPrefix}ENTER_RETURN_TAG`;
export const REMOVE_RETURN_TAG = `${pluginPrefix}REMOVE_RETURN_TAG`;
export const REPLACE_RETURN_TAG = `${pluginPrefix}REPLACE_RETURN_TAG`;
export const RESET_ALL_TAGS = `${pluginPrefix}RESET_ALL_TAGS`;

export type State = { [key: string]: string[] | [] };
